import { Result } from '@standardnotes/domain-core';
export class GetSharedVaults {
    constructor(getVaults) {
        this.getVaults = getVaults;
    }
    execute() {
        const vaults = this.getVaults
            .execute()
            .getValue()
            .filter((vault) => vault.isSharedVaultListing());
        return Result.ok(vaults);
    }
}
